<template lang="pug">
.listing(v-if="listing")
	.listing__content
		a(:href="listing.linkPath", :target="externalLink").listing__heading {{ listing.heading }}
		p.listing__metadata 
			i(v-if="listing.iconClass && listing.iconClass !== ''", :class="listing.iconClass")
			span(v-for="metadata in listing.metadata" v-html="metadata")
		p.listing__description(v-html = "listing.description")
	.listing__img(v-if="listing.img && listing.img.length > 0")
		img(:src="listing.img", :alt="listing.imgAltText")
</template>

<script>

export default {
	name: 'Listing',
	props: {
		listing: Object
	},
	data() {
		return {}
	},
	computed: {
		externalLink() {
			if (this.listing.externalLink) {
				return "_blank";
			} else {
				return "";
			}
		}
	},
	methods: {},
	mounted() {}
}
</script>

<style scoped lang="scss">
.listing {
	padding: 2.5rem 0 2.625rem;
	border-bottom: solid 1px $gray;
	display: flex;
	justify-content: space-between;
	@include mqdn(md) {
		flex-direction: column;
		padding: 1.25rem 0 2.5rem;
	}
	&:first-child {
		border-top: solid 1px $gray;
	}
	// &__content {}
	&__img {
		flex: 0 0 36%;
		margin-left: 1rem;
		position: relative;
		overflow: hidden;
		margin-bottom: auto;
		&::before {
			content:'';
			display: block;
			height: 0;
			padding-top: 64%;
		}
		img {
			position: absolute;
			height: 100%;
			width: 100%;
			top: 0;
			left: 0;
			object-fit: cover;
		}
		@include mqdn(lg) {
			flex: 0 0 40%;
			&::before {
				padding-top: 85%;
			}
		}
		@include mqdn(md) {
			margin: 0 auto 0.75rem;
			width: 100%;
			max-width: 500px;
			order: -1;
			&::before {
				padding-top: 57%;
			}
		}
	}
	&__heading {
		font-family: $fontFamilyBase;
		font-weight: 700;
		display: inline;
		position: relative;
		@include fluid(font-size, 1.5rem, 1.875rem);
		line-height: 38px;
		padding-bottom: 0.125rem;
		background-image: linear-gradient(to right, $red, $red);
		background-size: 44px 1px;
		background-position: 0% 100%;
		background-repeat: no-repeat;
		transition: 0.25s ease;

		&:hover {
			background-size: 100% 1px;
			color: $blue;
		}
	}
	&__metadata {
		margin-top: 0.75rem;
		font-family: $fontFamilyHeadings;
		color: #5f6e7d;
		margin-bottom: 0.375rem;
		@include fluid(font-size, 0.875rem, 1rem);
		i {
			margin-right: 0.5rem;
		}
		span {
			&:not(:last-child) {
				&::after {
					content: "|";
					margin: 0 0.75rem;
				}
			}
		}
	}
	&__description {
		margin-bottom: 0;
		@include fluid(font-size, 1rem, 1.125rem);
		@include fluid(line-height, 24px, 28px);
	}
}
</style>
